import { alertAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import getThemes, { ThemesKeys } from '../shared/themeShared';

const style = createMultiStyleConfigHelpers(alertAnatomy.keys);

const baseStyle = (theme: ThemesKeys) =>
  style.definePartsStyle({
    // define the part you're going to style
    title: {
      fontFamily: 'inter', // change the font family
      fontWeight: '600',
      fontSize: 'md',
      color: getThemes(theme).colors.palette.primary,
    },
    container: {
      background: getThemes(theme).colors.palette.success['80'],
    },
  });

const error = (theme: ThemesKeys) =>
  style.definePartsStyle({
    container: {
      background: getThemes(theme).colors.palette.errors['80'],
    },
  });

const warning = (theme: ThemesKeys) =>
  style.definePartsStyle({
    container: {
      background: getThemes(theme).colors.palette.warning['80'],
    },
  });

const pending = (theme: ThemesKeys) =>
  style.definePartsStyle({
    container: {
      background: getThemes(theme).colors.palette.pending['80'],
    },
  });

const feedback = (theme: ThemesKeys) =>
  style.definePartsStyle({
    container: {
      background: getThemes(theme).colors.palette.feedback['80'],
    },
  });

export const alertTheme = (theme: ThemesKeys) =>
  style.defineMultiStyleConfig({
    baseStyle: baseStyle(theme),
    variants: {
      error: error(theme),
      warning: warning(theme),
      pending: pending(theme),
      feedback: feedback(theme),
    },
  });

export default (theme: ThemesKeys) => alertTheme(theme);
